import { API_ADMIN_URL } from "../../../config/constants";
import { postRequest } from "../../API";

/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 24-12-2024 
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}cms/banner/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addEditData
* Description   : add/Edit Raffle winner
* By            : Md rashid Ali
* Date          : 14-01-2024 
*********************************************************/
export const addEditData = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}cms/banner/addeditdata`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : changeStatus
* Description   : change status
* By            : Md Rashd Ali
* Date          : 18-12-2024 
*********************************************************/
export const changeStatus = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}cms/banner/change-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : deleteWinner
* Description   : Delete Raffle winner
* By            : Md Rashid Ali
* Date          : 14-01-2024 
*********************************************************/
export const deleteBanner = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}cms/banner/delete`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : updateSeqOrder
* Description   : Update sequence order
* By            : AI Assistant
* Date          : 05-01-2025 
*********************************************************/
export const updateSeqOrder = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}cms/banner/update-seq-order`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function